import axios from 'axios'
import {Message} from "element-ui";

let http = axios.create({
    // baseURL: 'http://192.168.1.111:9001/',
    //baseURL: process.env.ADMIN_SERVER,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    },
    // transformRequest: [function (data) {
    //   let newData = '';
    //   for (let k in data) {
    //     if (data.hasOwnProperty(k) === true) {
    //       newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
    //     }
    //   }
    //   return newData;
    // }]
});

// 添加请求拦截器
http.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // ggg 线下测试
    // xyz 线上发布
    let token = localStorage.getItem('token') || 'ggg'
    let cgtoken = localStorage.getItem('cgtoken') || ''

    if (token) {
        config.headers['yxy-tenant-token'] = token
        config.headers['yxy-cg-token'] = cgtoken
        config.headers['request-id'] = Math.floor(Math.random() * 10000000000)
    }
    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    const res = response.data
    if (res.result == 'success' || res.error_code == 0) {
        return response
    } else {
        if (res.error_msg) { //人脸验证
            return response
        }else{
            Message({
                type: 'error',
                message: res.message || '系统错误请稍后再试！'
            });
            return response
        }
    }
}, function (error) {
    // 对响应错误做点什么
    throttle(Message({
        type: 'error',
        message: '系统错误请稍后再试！'
    }), 500);
    return Promise.reject(error)
});

function apiAxios(method, url, params, response) {
    http({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
    }).then(function (res) {
        response(res);
        // eslint-disable-next-line
    }).catch(function (err) {
    })
}

function apiAxiosReturnPromise(method, url, params) {
    return http({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
    })
}

function throttle(fn, threshhold) {
    let timeout
    let start = new Date;
    threshhold = threshhold || 500
    return function () {
        let context = this, args = arguments, curr = new Date() - 0
        clearTimeout(timeout)//总是干掉事件回调
        if (curr - start >= threshhold) {
            console.log("now", curr, curr - start)//注意这里相减的结果，都差不多是160左右
            fn.apply(context, args) //只执行一部分方法，这些方法是在某个时间段内执行一次
            start = curr
        } else {
            //让方法在脱离事件后也能执行一次
            timeout = setTimeout(function () {
                fn.apply(context, args)
            }, threshhold);
        }
    }
}

export default {
    get: function (url, params, response) {
        return apiAxios('GET', url, params, response)
    },
    post: function (url, params, response) {
        return apiAxios('POST', url, params, response)
    },
    postByReturnPromise: function (url, params) {
        return apiAxiosReturnPromise('POST', url, params)
    },
    put: function (url, params, response) {
        return apiAxios('PUT', url, params, response)
    },
    delete: function (url, params, response) {
        return apiAxios('DELETE', url, params, response)
    }
}
